import { Variant } from '../../product/dto/variant';
import { CopyableProductSection } from './copyable-product-section';
import { Menu } from '../menu';
import { CompanyConfiguration } from '../../company/dto/company-configuration';
import { LocationConfiguration } from '../../company/dto/location-configuration';
import { Type } from '@angular/core';
import { ProductSection } from './product-section';
import { ProductSectionItemComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-item/product-section-item/product-section-item.component';
import { ProductSectionItemExpandedProductInfoComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-item/product-section-item-expanded-product-info/product-section-item-expanded-product-info.component';

export class KillerQueenSection extends ProductSection {
  onDeserialize() {
    super.onDeserialize();
  }

  getMenuItemType(): Type<ProductSectionItemComponent> {
    return ProductSectionItemExpandedProductInfoComponent;
  }

  public copyWithout(
    menu: Menu,
    companyConfig: CompanyConfiguration,
    locationConfig: LocationConfiguration,
    variants: Variant[]
  ): CopyableProductSection {
    return this.copyWithoutHelper(KillerQueenSection, menu, companyConfig, locationConfig, variants);
  }
}
